(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
var core = module.exports = require('./core');

// mixin the deprecation features.
//Object.assign(core, require('./deprecation'));
core.extras = require('./extras');

// export PixiObjectModel globally.
global.POM = core;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./core":8,"./extras":11}],2:[function(require,module,exports){
module.exports={
  "name": "POM",
  "version": "0.0.1",
  "description": "Pixi Object Model",
  "author": "Grey Rook Entertainment",
  "main": "./src/index.js",
  "homepage": "",
  "bugs": "",
  "license": "",
  "licenseUrl": "",
  "repository": {
    "type": "git",
    "url": ""
  },
  "scripts": {
    "test_ci": "testem ci",
    "test": "karma start test/karma.conf.js",
    "docs": "jsdoc -c ./gulp/util/jsdoc.conf.json -R README.md"
  },
  "dependencies": {
    "async": "^0.9.0",
    "brfs": "^1.4.0",
    "earcut": "^2.0.0",
    "eventemitter3": "^1.0.1",
    "object-assign": "^2.0.0",
    "resource-loader": "^1.5.6"
  },
  "devDependencies": {
    "babelify": "^7.2.0",
    "browserify": "^9.0.8",
    "browserify-istanbul": "^0.2.1",
    "chai": "^2.2.0",
    "del": "^1.1.1",
    "gulp": "^3.8.11",
    "gulp-cached": "^1.0.4",
    "gulp-concat": "^2.5.2",
    "gulp-debug": "^2.0.1",
    "gulp-jshint": "^1.10.0",
    "gulp-mirror": "^0.4.0",
    "gulp-plumber": "^1.0.0",
    "gulp-rename": "^1.2.2",
    "gulp-sourcemaps": "^1.5.2",
    "gulp-uglify": "^1.2.0",
    "gulp-util": "^3.0.4",
    "ink-docstrap": "git+https://github.com/Pilatch/docstrap.git",
    "jasmine-core": "^2.2.0",
    "jsdoc": "^3.3.0-beta3",
    "jshint-summary": "^0.4.0",
    "minimist": "^1.1.1",
    "mocha": "^2.2.4",
    "karma-browserify": "^4.2.1",
    "karma-chai": "^0.1.0",
    "require-dir": "^0.3.0",
    "run-sequence": "^1.0.2",
    "testem": "^0.8.2",
    "vinyl-buffer": "^1.0.0",
    "vinyl-source-stream": "^1.1.0",
    "watchify": "^3.1.2"
  }
}

},{}],3:[function(require,module,exports){
'use strict';

var ContainerElement = require('./elements/ContainerElement'),
    SpriteElement = require('./elements/SpriteElement'),
    GraphicsElement = require('./elements/GraphicsElement');

/**
 * POM Manager main container
 * @class Manager
 * @extends PIXI.Container
 * @memberof POM
 * @constructor
 */
function Manager(data) {
    /**
     * list of all known element constructors
     *
     * @private
     */
    this._elementPrototypes = {
        'container': ContainerElement,
        'graphics': GraphicsElement,
        'sprite': SpriteElement
    };

    this._plugins = {};

    ContainerElement.call(this, this, data);
}

Manager.prototype = Object.create(ContainerElement.prototype);
module.exports = Manager;

/**
 * create new element from given data (see elements folder)
 *
 * if no matching prototype is registered an exception is thorwn.
 *
 * @param data {Object} contains information about the element
 * @returns new instance of an element
 */
Manager.prototype.createElementFromData = function (data) {
    var type = data.type;
    if (type in this._elementPrototypes) {
        return new this._elementPrototypes[type](this, data);
    }
    throw new Error('Cannot create element of unknown type ' + type);
};

/**
 * register new element prototype
 *
 * @param type {String} name of the element
 * @param elementPrototype {Element} base class for the element
 */
Manager.prototype.registerPrototype = function (name, elementPrototype) {
    this._elementPrototypes[name] = elementPrototype;
};

/**
 * Adds a plugin to an object
 *
 * @param pluginName {string} The name of the plugin.
 * @param ctor {Object}
 */
Manager.prototype.registerPlugin = function (pluginName, ctor) {
    this._plugins[pluginName] = ctor;
};

/**
 * Instantiate all plugins of this object
 */
Manager.prototype.initPlugins = function () {
    this.plugins = this.plugins || {};

    for (var o in this._plugins) {
        this.plugins[o] = new this._plugins[o](this);
    }
};

/**
 * Remove all the plugins of this object
 */
Manager.prototype.destroyPlugins = function () {
    for (var o in this.plugins) {
        this.plugins[o].destroy();
        this.plugins[o] = null;
    }

    this.plugins = null;
};

Manager.prototype.destroy = function () {
    this.destroyPlugins();
    ContainerElement.prototype.destroy.call(this, true);
};

},{"./elements/ContainerElement":5,"./elements/GraphicsElement":6,"./elements/SpriteElement":7}],4:[function(require,module,exports){
/**
 * Constant values used in POM.Manager
 *
 * @lends MANAGER
 */
var CONST = {
  /**
   * String of the current POM.Manager version
   *
   * @static
   * @constant
   * @property {string} VERSION
   */
  VERSION: require('../../package.json').version,
  DEFAULT_DATAKEYS: ['name', ['position', 'x'], ['position', 'y'], ['scale', 'x'], ['scale', 'y'], 'alpha', 'rotation', ['pivot', 'x'], ['pivot', 'y']]
};

module.exports = CONST;

},{"../../package.json":2}],5:[function(require,module,exports){
var updateData = require('../../extras/updateData');
var getData = require('../../extras/getData');
var setData = require('../../extras/setData');
var CONST = require('../const');
var helpers = require('../../extras/helpers');

/**
 * POM Container Element
 * @class ContainerElement
 * @extends PIXI.Container
 * @memberof POM
 * @constructor
 * @param manager the core manager
 * @param data data for the element
 */
function ContainerElement(manager, data) {
    PIXI.Container.call(this);
    this.manager = manager;
    this.type = 'container';
    this.minWidth = 0;
    this.minHeight = 0;
    this._hasFlags = this._updateFlags.length > 0;
    this.updateData(data || {});
}

ContainerElement.prototype = Object.create(PIXI.Container.prototype);
module.exports = ContainerElement;

ContainerElement.prototype._updateFlags = [];

/**
 * Update data of objects from JSON decoded object
 *
 * @param data {Object} JSON decoded object representing the content
 */
ContainerElement.prototype.updateData = function (data) {
    if (data.children) {
        this.updateChildren(data.children);
    }

    updateData(this, data);
};

/**
 * Sets data of objects from JSON decoded object
 *
 * @param data {Object} JSON decoded object representing the content
 */
ContainerElement.prototype.setData = function (data) {
    data = data || {};

    this.setChildren(data.children);
    setData(this, data);
};

/**
 * get data of SpriteElement (including defaults)
 *
 * @returns data {Object} representing the container (and its children)
 */
ContainerElement.prototype.getData = function () {
    var children = [];
    for (var i = 0; i < this.children.length; i++) {
        children.push(this.children[i].getData());
    }
    var data = getData(this);
    data.children = children;
    return data;
};

/**
 * Removes element with a given name - if it exists.
 * searches all children for the element with this name
 *
 * @param name {String} The name of the element to be removed
 */
ContainerElement.prototype.removeChildByNameRecursive = function (name) {
    var child = this.getChildByNameRecursive(name);
    if (child) {
        child.parent.removeChild(child);
    }
};

/**
 * Get element with given name - if it exists.
 * searches all children for the element with this name
 *
 * @param name {String} The name of the element to be found
 */
ContainerElement.prototype.getChildByNameRecursive = function (name) {
    for (var i = 0; i < this.children.length; i++) {
        var child = this.children[i];
        if (child.name == name) {
            return child;
        }
        if (typeof child.getChildByNameRecursive !== 'undefined') {
            child = child.getChildByNameRecursive(name);
            if (child !== null) {
                return child;
            }
        }
    }
    return null;
};

/**
 * Generate children from JSON data
 *
 * @param children {Array} data of children
 * @private
 */
//TODO Evaluate whether an UPDATE function should remove ALL data, instead of replacing old data with new data
ContainerElement.prototype.updateChildren = function (children) {
    this.destroyChildren();
    for (var i = 0; i < children.length; i++) {
        this.addChild(this.manager.createElementFromData(children[i]));
    }
};

ContainerElement.prototype.destroyChildren = function () {
    var children = this.removeChildren();
    for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child.destroy) {
            child.destroy();
        }
    }
};

ContainerElement.prototype.setChildren = function (children) {
    if (children) {
        this.destroyChildren();
        for (var i = 0; i < children.length; i++) {
            this.addChild(this.manager.createElementFromData(children[i]));
        }
    }
};

ContainerElement.prototype._getDataKeys = function () {
    return helpers.deepClone(CONST.DEFAULT_DATAKEYS);
};

ContainerElement.prototype.toLocal = function (global, from) {
    if (this.resizeScaling) {
        var local = PIXI.Container.prototype.toLocal.call(this, global, from);
        local.x *= this.localScaleX;
        local.y *= this.localScaleY;

        return local;
    } else {
        return PIXI.Container.prototype.toLocal.call(this, global, from);
    }
};

ContainerElement.prototype._checkFlags = function () {
    for (var i = 0, j = this._updateFlags.length; i < j; i++) {
        var flag = this._updateFlags[i];

        if (this[flag.name]) {

            var func;
            if (typeof flag.func === 'string') {
                func = this[flag.func];
            } else {
                func = flag.func;
            }

            if (func) {
                this[flag.name] = func.call(this);
            } else {
                console.log('Could not update flag ' + flag.name + ' on Element of type ' + this.type);
            }
        }
    }
};

// TODO add a toGlobal function too
// TODO merge this with GOWN.utils.resizeScaling
ContainerElement.prototype.updateTransform = function () {

    var i, j;
    var wt = this.worldTransform;
    // obmit Control.updateTransform as it calls redraw as well
    if (!this.resizeScaling) {
        if (this.redraw) {
            this.redraw(1, 1);
        }

        if (this._hasFlags) {
            this._checkFlags();
        }

        PIXI.Container.prototype.updateTransform.call(this);
    } else {
        var pt = this.parent.worldTransform;
        var scaleX = Math.sqrt(Math.pow(pt.a, 2) + Math.pow(pt.b, 2));
        var scaleY = Math.sqrt(Math.pow(pt.c, 2) + Math.pow(pt.d, 2));
        this.worldWidth = Math.round(Math.max(this.width * scaleX, this.minWidth));
        this.worldHeight = Math.round(Math.max(this.height * scaleY, this.minHeight));

        PIXI.DisplayObject.prototype.updateTransform.call(this);

        // revert scaling
        var tx = wt.tx;
        var ty = wt.ty;

        wt.scale(scaleX !== 0 ? 1 / scaleX : 0, scaleY !== 0 ? 1 / scaleY : 0);
        wt.tx = tx;
        wt.ty = ty;

        if (this.redraw) {
            this.redraw(scaleX, scaleY);
        }

        this.localScaleX = scaleX;
        this.localScaleY = scaleY;

        if (this._hasFlags) {
            this._checkFlags();
        }

        for (i = 0, j = this.children.length; i < j; ++i) {
            this.children[i].updateTransform();
        }
    }
};

// performance increase to avoid using call.. (10x faster)
//Copied from PIXI //TODO Actually use this
ContainerElement.prototype.pomContainerUpdateTransform = ContainerElement.prototype.updateTransform;

Object.defineProperties(ContainerElement.prototype, {
    dataKeys: {
        get: ContainerElement.prototype._getDataKeys
    }
});

},{"../../extras/getData":9,"../../extras/helpers":10,"../../extras/setData":12,"../../extras/updateData":13,"../const":4}],6:[function(require,module,exports){
var updateData = require('../../extras/updateData');
var getData = require('../../extras/getData');
var CONST = require('../const');

/**
 * POM Graphics Element
 * @class GraphicsElement
 * @extends PIXI.Graphics
 * @memberof POM
 * @constructor
 * @param manager {Manager} the core POM Manager
 * @param data {Object} data for the element
 */
function GraphicsElement(manager, data) {
  PIXI.Graphics.call(this);
  /**
   * @var dataKeys {Object} datakeys (just the default)
   */
  this.dataKeys = CONST.DEFAULT_DATAKEYS;
  this.manager = manager;
  this.type = 'graphics';
  this.updateData(data || {});
}

GraphicsElement.prototype = Object.create(PIXI.Graphics.prototype);
module.exports = GraphicsElement;

/**
 * update data of graphics from JSON decoded object
 *
 * @param data {Object} JSON decoded object representing the content
 */
GraphicsElement.prototype.updateData = function (data) {
  updateData(this, data);
};

/**
 * get data of SpriteElement (including defaults)
 *
 * @returns data {Object} representing the graphics element
 */
GraphicsElement.prototype.getData = function () {
  return getData(this);
};

},{"../../extras/getData":9,"../../extras/updateData":13,"../const":4}],7:[function(require,module,exports){
var updateData = require('../../extras/updateData');
var getData = require('../../extras/getData');
var CONST = require('../const');

/**
 * POM Manager Sprite Element
 * @class SpriteElement
 * @extends PIXI.Container
 * @memberof POM
 * @constructor
 * @param manager {Manager} the core manager
 * @param data {Object} data for the element
 */
function SpriteElement(manager, data) {
    PIXI.Sprite.call(this);

    /**
     * @var dataKeys {Object} datakeys (just the default and source)
     */
    this.dataKeys = CONST.DEFAULT_DATAKEYS.splice();
    this.dataKeys.push('source');
    this.manager = manager;
    this.type = 'sprite';
    this.updateData(data || {});
}

SpriteElement.prototype = Object.create(PIXI.Sprite.prototype);
module.exports = SpriteElement;

/**
 * update data of sprite from JSON decoded object
 *
 * @param data {Object} JSON decoded object representing the content
 */
SpriteElement.prototype.updateData = function (data) {
    updateData(this, data);
};

/**
 * get data of SpriteElement (including defaults)
 *
 * @returns data {Object} representing the sprite
 */
SpriteElement.prototype.getData = function () {
    return getData(this);
};

/**
 * set image source
 *
 * @var source {String} image url to a texture source.
 */
Object.defineProperty(SpriteElement.prototype, 'source', {
    set: function (value) {
        this.texture = PIXI.Texture.fromImage(value);
    },
    get: function () {
        return this.texture.baseTexture.imageUrl;
    }
});

},{"../../extras/getData":9,"../../extras/updateData":13,"../const":4}],8:[function(require,module,exports){
/**
 * @file        Main export of the PixiObjectModel core library
 * @author      Grey Rook Entertainment
 * @copyright   2015 Grey Rook Entertainment
 */

/**
 * @namespace POM
 */
module.exports = Object.assign(require('./const'), {
  Manager: require('./Manager'),
  ContainerElement: require('./elements/ContainerElement'),
  GraphicsElement: require('./elements/GraphicsElement'),
  SpriteElement: require('./elements/SpriteElement')
});

},{"./Manager":3,"./const":4,"./elements/ContainerElement":5,"./elements/GraphicsElement":6,"./elements/SpriteElement":7}],9:[function(require,module,exports){
'use strict';

function getValues(element) {
    var values = {};
    var property, data, key;
    var elem = element;

    for (var i = 0; i < element.dataKeys.length; i++) {
        property = element.dataKeys[i];
        try {
            if (typeof property == 'function') {
                values[property] = element[property]();
            } else if (typeof property === 'string') {
                values[property] = element[property];
            } else {
                elem = element;
                key = property;
                data = values;
                while (key.length > 1) {
                    var k = key.shift();
                    if (!data.hasOwnProperty(k)) {
                        data[k] = {};
                    }
                    data = data[k];
                    elem = elem[k];
                }
                key = key[0];
                data[key] = elem[key];
            }
        } catch (e) {
            if (console && console.error) {
                console.error('Property "' + property + '" could not be gotten from Element ' + element.name + ' of type "' + element.type + '"');
                console.error(e.message);
            }

            values[property] = undefined;
        }
    }
    return values;
}

/**
 * get describing data for element (position, style, ...)
 *
 * @returns {Object} data
 */
function getData(element) {
    return {
        'type': element.type,
        'values': getValues(element)
    };
}

module.exports = getData;

},{}],10:[function(require,module,exports){
'use strict';

function deepClone(object) {
    try {
        var type = typeof object;
        var clone;
        if (type === 'boolean' || type === 'string' || type === 'number') {
            return object;
        } else if (isArray(object)) {
            clone = [];
            for (var i in object) {
                clone.push(deepClone(object[i]));
            }
            return clone;
        } else if (type === 'function') {
            return object; //Is this correct?
        } else if (type === 'object' && object !== null) {
                clone = {};

                for (var name in object) {
                    clone[name] = deepClone(object[name]);
                }

                return clone;
            } else {
                return null;
            }
    } catch (e) {
        if (console && console.error) {
            console.error('Object could not be cloned');
            console.error(object);
            console.error(e.message);
        }
    }
}

function isArray(array) {
    return Object.prototype.toString.call(array) === '[object Array]';
}

function deepCompare(object1, object2) {
    var type1 = typeof object1;
    var type2 = typeof object2;

    if (type1 != type2) {
        return false;
    } else if (type1 === 'boolean' || type1 === 'string' || type1 === 'number') {
        return object1 == object2;
    } else if (isArray(object1)) {
        if (!isArray(object2)) {
            return false;
        }
        for (var i in object1) {
            var child1 = object1[i];
            var child2 = object2[i];
            if (!deepCompare(child1, child2)) {
                return false;
            }
        }

        if (object1.length != object2.length) {
            return false;
        }
    } else if (type1 === 'function') {
        return object1 == object2; //TODO Better check
    } else if (type1 === 'object') {
            if (object1 == null && object2 || object2 == null && object1) {
                return false;
            } else {
                var checked = [];
                var name;
                for (name in object1) {
                    if (!deepCompare(object1[name], object2[name])) {
                        return false;
                    }
                    checked.push(name);
                }

                for (name in object2) {
                    if (checked.indexOf(name) < 0 && !deepCompare(object2[name], object1[name])) {
                        return false;
                    }
                }
            }
        } else {
            return null;
        }

    return true;
}

module.exports = {
    deepCompare: deepCompare,
    isArray: isArray,
    deepClone: deepClone
};

},{}],11:[function(require,module,exports){
/**
 * @file        Main export of the POM extras library
 * @author      Grey Rook Entertainment
 * @copyright   2015 Grey Rook Entertainment
 */
module.exports = {
    updateData: require('./updateData'),
    getData: require('./getData'),
    setData: require('./setData'),
    helpers: require('./helpers')
};

},{"./getData":9,"./helpers":10,"./setData":12,"./updateData":13}],12:[function(require,module,exports){
'use strict';

var helpers = require('./helpers');

function _setValue(elem, value, key) {

    if (typeof elem[key] == 'function') {
        var args = value[key];
        if (!helpers.isArray(args)) {
            args = [args];
        }
        elem[key].apply(elem, args);
    } else if (value[key] && typeof value[key] === 'object') {

        //First we remove all previous data
        if (helpers.isArray(value[key])) {
            elem[key] = [];
        } else if (!elem[key]) {
            elem[key] = {}; //We cant do this all the time because we might have an object of a specific class
        }

        for (var k in value[key]) {
            _setValue(elem[key], value[key], k);
        }
        elem[key] = elem[key];
    } else {
        // set string, int, ... value directly
        elem[key] = value[key];
    }
}

/**
 * update data for element
 *
 * @param element {Object} some element
 * @param values {Object} data that need to be set for the object
 */
function setValues(element, values) {
    for (var property in values) {
        try {
            _setValue(element, values, property);
        } catch (e) {
            if (console && console.error) {
                console.error('Property "' + property + '" could not be set on Element ' + element.name + ' of type "' + element.type + '"');
                console.error(e.message);
            }
        }
    }
}

function setData(element, data) {
    setValues(element, data.values || {});
}

module.exports = setData;

},{"./helpers":10}],13:[function(require,module,exports){
'use strict';

var helpers = require('./helpers');

function _setValue(elem, value, key) {
    if (value[key] && typeof value[key] === 'object') {
        /**
         If the upper level value does not exist yet,
         we have to create an array or object,
         so that the lower level values can be added
         **/
        if (!elem[key]) {
            if (helpers.isArray(value[key])) {
                elem[key] = [];
            } else {
                elem[key] = {};
            }
        }

        for (var k in value[key]) {
            _setValue(elem[key], value[key], k);
        }
        elem[key] = elem[key];
    } else {
        // set string, int, ... value directly
        elem[key] = value[key];
    }
}

/**
 * update data for element
 *
 * @param element {Object} some element
 * @param values {Object} data that need to be set for the object
 */
function updateValues(element, values) {
    // preinitialize variable
    var elem = element;

    for (var property in values) {
        _setValue(elem, values, property);
    }
}

function updateData(element, data) {
    updateValues(element, data.values || {});
}

module.exports = updateData;

},{"./helpers":10}]},{},[1])

